import { Component, OnInit, OnDestroy } from '@angular/core';
import { VersionCheckService } from '../../../services/version-check.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-update-notification',
    templateUrl: './update-notification.component.html',
    styleUrls: ['./update-notification.component.css']
})
export class UpdateNotificationComponent implements OnInit, OnDestroy {
    showNotification = false;
    private subscription?: Subscription;

    constructor(private versionCheckService: VersionCheckService) { }

    ngOnInit(): void {
        // Subscribe to update notifications
        this.subscription = this.versionCheckService.updateAvailable$.subscribe(
            updateAvailable => {
                this.showNotification = updateAvailable;
            }
        );
    }

    /**
     * Handle click on the notification
     * Reload the app to get the latest version
     */
    onUpdateClick(): void {
        this.versionCheckService.reloadApp();
    }

    /**
     * Dismiss the notification
     */
    onDismiss(): void {
        this.showNotification = false;
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
